import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "newsltters-header-container" }
const _hoisted_2 = { class: "button-container" }
const _hoisted_3 = { style: {"height":"45vh"} }

import { PropType, ref } from "vue";
import { ContextMenuItem } from "@/types/ui/menus/ContextMenuItem";
import GridBase from "../grid/grid-base.vue";
import { DxColumn } from "devextreme-vue/data-grid";
import { Newsletter } from "@/types/emails/Newsletter";
import GridMenu from "../grid/grid-menu.vue";
import DxButton from "devextreme-vue/button";


export default /*#__PURE__*/_defineComponent({
  __name: 'newsletter-articles',
  props: {
  /**
   * An array of newsletters to be displayed or processed by the component.
   * @type {Newsletter[]}
   * @required
   */
  dataSource: {
    type: Array as PropType<Newsletter[]>,
    required: true,
  },
},
  emits: [
  "newsletterRowSelected",
  "newsletterRowClick",
  "newsLetterMenuItemClick",
  "onRowReorder",
],
  setup(__props, { emit }) {



const exportGrid = ref(false);
const loading = ref<false>();


const contextMenuId = ref("newsletter-article-modal-menu-item");
const menuItems = ref<ContextMenuItem[]>([
  { key: "new", text: "New", icon: "fas fa-plus" },
  { key: "edit", text: "Edit", icon: "fas fa-pencil" },
  { key: "delete", text: "Delete", icon: "fas fa-trash" },
  { key: "export", text: "Export to Excel", icon: "fas fa-download" },
  { key: "refresh", text: "Refresh", icon: "fas fa-redo" },
]);

const handleRowSelected = (row: Newsletter) => {
  if (!row) return;

  emit("newsletterRowSelected", row);
};

const handleRowClick = (row: Newsletter) => {
  if (!row) return;

  emit("newsletterRowClick", row);
};

const onMenuItemClicked = async (key: string) => {
  switch (key) {
    case "export":
      exportGrid.value = true;
      break;
    default:
      emit("newsLetterMenuItemClick", key);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(DxButton), {
          icon: "fas fa-plus",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('newsLetterMenuItemClick', 'new')))
        }),
        _createVNode(GridMenu, {
          "menu-items": menuItems.value,
          onItemClicked: onMenuItemClicked,
          "button-icon": "fas fa-bars",
          id: contextMenuId.value
        }, null, 8, ["menu-items", "id"])
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(GridBase, {
        dataSource: __props.dataSource,
        "id-column-name": "newsId",
        loading: loading.value,
        "show-action-button": true,
        "column-auto-width": true,
        onRowSelected: handleRowSelected,
        onRowClick: handleRowClick,
        showSearchPanel: true,
        "run-export": exportGrid.value,
        "onUpdate:runExport": _cache[1] || (_cache[1] = ($event: any) => ((exportGrid).value = $event)),
        allowReordering: true,
        onOnRowReorder: _cache[2] || (_cache[2] = (e) => emit('onRowReorder', e))
      }, {
        columns: _withCtx(() => [
          _createVNode(_unref(DxColumn), {
            "data-field": "newsId",
            caption: "NewsId",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "subject",
            caption: "Subject",
            "hiding-priority": 2
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "displayOrder",
            caption: "Order",
            alignment: "center",
            width: "175px",
            "hiding-priority": 1
          })
        ]),
        _: 1
      }, 8, ["dataSource", "loading", "run-export"])
    ])
  ], 64))
}
}

})